<div class="loginPage">
  <div class="header-div d-flex align-items-center">
    <div class="d-flex align-items-center">
      <div class="logo-div">
        <img src="/assets/images/Piqet_NewLogo.svg" alt="Logo" />
      </div>
      <div class="go-back-div">
        <i class="bi bi-arrow-left"></i>
        <a routerLink="/login">Go back</a>
      </div>
    </div>
  </div>

  <div class="text-center mb-5 mt-5" *ngrxLet="authFacade.activationData$ as activationData">
    <p class="text-dark p-0 m-0">
      <span class="content-text">{{
        activationData.includes('Empty') ? 'Your activation code is not valid.' : activationData
      }}</span>
    </p>
  </div>

  <div class="text-center mb-3">
    <a class="linkText" *ngIf="!UID; else dashboardLink" routerLink="/login"> Login here </a>

    <ng-template #dashboardLink>
      <a class="linkText" routerLink="/dashboard">Back to dashboard</a>
    </ng-template>
  </div>

  <div class="copyright">
    <a class="linkText" href="http://www.lifecycles.com.au/" target="_blank"
      >© Life Cycle Strategies Pty Ltd</a
    >
  </div>
</div>
